import React from 'react';
import classes from '../InviteFriend.module.scss';

export default <div className={classes.infoContainer}>
  <h1>
    Получи <mark>50 FREESPIN</mark> на сумму 10 лари в подарок в слоте -{' '}
    <mark>20 Burning Hot</mark>
    <br />
    <span style={{ display: 'block', marginTop: '1rem' }}>
        за каждого приглашенного и верифицированного друга
      </span>
  </h1>
  <section>
    <h2>Регистрация</h2>
    <p>1. После авторизации, нажми на кнопку – Пригласить в твоем аккаунте.</p>
    <p>
      2. Введи номер мобильного телефона и личный номер того лица, которого ты хотел бы пригласить и нажми на кнопку – Продолжить
    </p>
    <p>
      3. На указанный номер будет отправлен SMS код. Введи код в соответствующую графу и нажми на кнопку – Подтвердить
    </p>
    <p>
      4. После проверки номера, введи электронную почту и имя пользователя(username), прочти и отметь необходимую графу и нажми на кнопку – Завершить
    </p>
  </section>
  <section>
    <h2>Верификация</h2>
    <p>
      5. После завершения процесса регистрации, дождись пока друг загрузит документы и пройдет верификацию или если ты желаешь сам провести верификацию друга, нажми на кнопку – Загрузить документы
    </p>
    <p>
      6. Выбери удостоверение личности или паспорт, загрузи обе стороны документа твоего друга, его селфи и нажми на кнопку – Загрузить Документы
    </p>
    <p>
      7. Документы загружены для верификации. Ты сможешь следить за статусом твоего друга в списке.
    </p>
  </section>
  <section>
    <h2>Как проверить статус друга?</h2>
    <p>
      Этап процесса верификации отображен в списке приглашенных друзей, в поле статуса:
    </p>
    <p>
      Верификация – Процесс верификации еще не начался. при нажатии на кнопку начнется процесс загрузки документов и верификации.
    </p>
    <p>
      В процессе – Документы загружены и идет процесс обработки информации.
    </p>
    <p>
      Обновление – Процесс верификации прерван и нужно загрузить повреждены документ заново.
    </p>
    <p>
      Отклонено – информация проверена и верификация пользователя прошла безуспешно.
    </p>
    <p>
      Завершено – если поле отображается зеленым цветом, процесс верификации прошел успешно и у тебя скоро активируется подарок - <mark>50 FREESPIN</mark>.
    </p>
    <br />
    <p>
      Активируй дополнительные подарки в слоте - <mark>20 Burning Hot</mark>, 10, 30 და 50 после регистрации 10, 30 и 50 пользователей:
    </p>
    <ul>
      <li>
        10 друзей: <mark>+100 FREESPIN</mark>
      </li>
      <li>
        30 друзей: <mark>+300 FREESPIN</mark>
      </li>
      <li>
        50 друзей: <mark>+500 FREESPIN</mark>
      </li>
    </ul>
    <p>
      Подарки будут начислены в течение 30 минут после завершения верификации.
    </p>
  </section>
</div>